import { Injectable } from '@angular/core';

@Injectable()
export class UiStorage {
    private _data: any;
    private _afd: any;

    public save(data: any) {
        this._data = data;
    }

    public load(): any {
        return this._data;
    }

    public saveAfd(afd: any) {
        this._afd = afd;
    }

    public loadAfd(): any {
        return this._afd;
    }
}
